import React from 'react';
import { X } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import type { DashboardAssistantDockSession } from '../../../../contexts/DashboardAssistantDockContext';
import { isSmartTaggingSession } from '../../../../utils/smartTaggingSessions';

export function SessionChip({
  chipRef,
  session,
  isActive,
  onOpen,
  onClose,
}: {
  chipRef?: React.Ref<HTMLDivElement>;
  session: DashboardAssistantDockSession;
  isActive: boolean;
  onOpen: () => void;
  onClose: () => void;
}) {
  // Smart Tagging sessions keep their branded label — the server derives
  // thread titles from the first message, which would otherwise replace it.
  const isSmartTagging = isSmartTaggingSession(session.id);
  const chipTitle = isSmartTagging ? 'Smart Tagging' : session.title;
  return (
    <div
      ref={chipRef}
      className={`group relative flex h-8 max-w-[220px] shrink-0 items-center rounded-lg border px-3 text-xs transition ${
        isActive
          ? 'border-edge bg-white text-ink shadow-sm'
          : 'border-transparent bg-transparent text-ink-muted hover:border-edge/60 hover:bg-white/70 hover:text-ink'
      }`}
    >
      <button
        onClick={onOpen}
        className="flex min-w-0 flex-1 items-center gap-2 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
        type="button"
      >
        <span className="truncate font-medium">{chipTitle}</span>
      </button>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={onClose}
            className="absolute right-2 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-white/90 text-ink-muted opacity-0 transition hover:text-ink focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 group-hover:opacity-100 group-focus-within:opacity-100"
            type="button"
            aria-label={`Close ${chipTitle}`}
          >
            <X className="h-3 w-3" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">Close chat session</TooltipContent>
      </Tooltip>
    </div>
  );
}
